import React,{ useState,useContext,useRef ,useEffect} from 'react';
import { useForm,Controller } from 'react-hook-form';
import { ElementContext } from '../../../../services/Context/Context';
import Api from '../../../../services/Api';
import ColorSelect from "../../../CouleurSelect/CouleurSelect";
import OtherColors from "../../ModalForm/Step/OtherColors";
import { pays } from '../../../../utils/pays_fr';
import AddChassisModal from '../../ModalForm/AddChassis/AddChassisModal';
const StepOne = ({nextStep,paiement,setPaiement,handleInput}) => {
    const { register, handleSubmit, formState: { errors },control, setError,setValue } = useForm();
    const api = new Api();
    const [typeAutorisations,setTypeAutorisations ] = useState(["transit","circulation temporaire"]);  
    const { elementsData } = useContext(ElementContext); 
    const { categories,marques,modeles } = elementsData || { categories: [],marques:[],modeles:[]};
 
    const [selectModeles,setSelectedModeles ] = useState([]);
    const [showModal,setShowModal] = useState(false);
    const [showOtherColor,setShowOtherColor] = useState(false);
    const inputRef = useRef(null);
    const [numeroChassis, setNumeroChassis] = useState(
      paiement.infovehicule.numeroChassis?.[0] || ""
    );
    const submit = (data) => {
        //console.log(data);
        nextStep();
    }
    const ChassisComponent = ({ setShowModal }) => {
    
        const addChassis = () => {
          setShowModal(true);
          setError("infovehicule.numeroChassis","");
        }
     
        return (
          <>
          
             <label className='obligatoire'>Numéro de chassis
               {(paiement.typeDemandeur === "concessionnaire" || paiement.typeDemandeur === "constructeur") ? (
                 <>
                 <input
                    type="hidden"
                    {...register("infovehicule.numeroChassis", {
                      validate: {
                        notEmpty: () => paiement.infovehicule.numeroChassis.length > 0 || "Vous devez ajouter au moins un numéro de chassis"
                      }
                    })}
                    value={ paiement.infovehicule?.numeroChassis.length > 0 ?  paiement.infovehicule?.numeroChassis?.join(","):""} // This ensures the validation triggers
                 />
                 <input 
                     onFocus={addChassis}
                     readOnly={true}
                     value={paiement.infovehicule.numeroChassis ? paiement.infovehicule.numeroChassis.join(", "):""}
                     id='numeroChassis'
                  />
                 </>
                 
                ):
                <input 
                  type='text'
                  name='numeroChassis'
                  className='chassis-input'
                  placeholder="Numéro de chassis du véhicule"
                  
                  value={paiement.infovehicule.numeroChassis?.[0] || ""}
                  {...register("numeroChassis", {
                    required: "Le numéro de chassis est obligatoire",
                    minLength: {
                      value: 1,
                      message: "Le numéro de chassis doit contenir au moins 1 caractère"
                    },
                    maxLength: {
                      value: 17,
                      message: "Le numéro de chassis ne doit pas dépasser 17 caractères"
                    },
                    pattern: {
                      value: /^[A-HJ-NPR-Z0-9]{1,17}$/i, // Standard VIN pattern
                      message: "Format de chassis invalide"
                    }
                  })}
                  onChange={(e) => {
                    setPaiement(prev => ({
                      ...prev,
                      infovehicule: {
                        ...prev.infovehicule,
                        numeroChassis: [e.target.value] // Store as array with single element
                      }
                    }));
              
                    setValue("infovehicule.numeroChassis", [e.target.value]);
                  }}
                  />
                } 
               {errors.infovehicule?.numeroChassis && (
                <>
                  {["required", "minLength", "maxLength", "pattern", "validate", "notEmpty"].map((errorType) => (
                    errors.infovehicule.numeroChassis?.type === errorType && (
                      <span key={errorType} className="error-msg">
                        {errors.infovehicule.numeroChassis.message}
                      </span>
                    )
                  ))}
                </>
              )}
             </label>
          </>
             
        )
    }
    const getData = async () => {
         const response = await api.apiData("get",`/paiement/apc/invoice?invoice_id=${paiement.id}`);
        // console.log(response?.data);
         if(response.status === 200){
           if( Array.isArray(response.data) && response.data.length > 0){
              //  console.log(response.data[0]);
             // console.log(response.data);
              setPaiement({
                ...paiement,
                typeDemandeur:response.data[0].typeDemandeur,
                infovehicule:{
                    ...paiement.infovehicule,
                    marque:response.data[0].marque_id,
                    modele:response.data[0].modele_id,
                    categorie:response.data[0].categorie_id,
                    ptac:response.data[0].ptac,
                    poidsAVide:response.data[0].poidsAVide,
                    puissanceFiscale:response.data[0].puissanceFiscale,
                    chargeUtile:response.data[0].chargeUtile,
                    couleur:response.data[0].couleur,
                    otherColor:paiement.infovehicule.otherColor === 'null' ? "" :paiement.infovehicule.otherColor,
                    numeroChassis:response.data.map((item) => item.numeroChassis),
                    dateMiseCirculation:response.data[0].dateMiseCirculation,
                    paysProvenance:response.data[0].paysProvenance,
                    paysDestination:response.data[0].paysDestination,
                    loadedDossier:response.data[0].dossierPath,
                    poidsTotalRoulant:response.data[0].poidsTotalRoulant,
                    dossier: response.data[0].dossier ? [response.data[0].dossier] : [],
                 
                },
                demandeur:{
                    ...paiement.demandeur,
                    fullName:response.data[0].fullName,
                    adresse:response.data[0].adresse,
                    telephone:response.data[0].telephone,
                    email:response.data[0].email,
                    nina:response.data[0].nina,
                    denominationSociete:response.data[0].denomination_societe,
                    rccm:response.data[0].rccm,
                }
              });
              setValue("marque",response.data[0].marque_id);
              setValue("categorie",response.data[0].categorie_id);
              setValue("modele",response.data[0].modele_id);
              setValue("ptac",response.data[0].ptac);
              setValue("poidsAVide",response.data[0].poidsAVide);
              setValue("puissanceFiscale",response.data[0].puissanceFiscale);
              setValue("chargeUtile",response.data[0].chargeUtile);
              setValue("dateMiseCirculation",response.data[0].dateMiseCirculation);
              setValue("paysProvenance",response.data[0].paysProvenance);
              setValue("paysDestination",response.data[0].paysDestination);
              setValue("couleur",response.data[0].couleur);
              setValue("otherColor",response.data[0].otherColor);
              setValue("numeroChassis",response.data.map((item) => item.numeroChassis).join(","));
             
           }
         }
    }
    useEffect(() => {
        setSelectedModeles(modeles.filter((p) => p.marque_id == paiement.infovehicule.marque));
        getData();
    },[paiement.infovehicule.marque]) ;
 
  return (
    
     <div className='step-component step-one'>
        {showModal && <AddChassisModal 
                        isOpen={showModal}
                        setIsOpen={setShowModal} 
                        paiement={paiement}
                        setPaiement={setPaiement}
                    />}
        {showOtherColor && <OtherColors 
            isOpen={showOtherColor}
            setIsOpen={setShowOtherColor} 
            handleInput={handleInput}
            paiement={paiement}
         />}
        <h1>Edition</h1>
        <form onSubmit={handleSubmit(submit)}>
         <div className='input-group'>
           <label className='obligatoire'>Categorie de Vehicule
               <select
                 name='categorie'
                 value={paiement?.infovehicule?.categorie || ""}
                 {...register("categorie", {
                    onChange: (e) => {
                       handleInput(e);
                    },
                   validate: (value) => value !== "" || "Ce champ est obligatoire"
                 })}
                 >
                 <option value="">---</option>
                 {categories?.map((cat) => (
                  <option value={cat.categorie_id} key={cat.categorie_id}>
                    {cat.nomCategorie}
                  </option>
                ))}
               </select> 
               {errors?.categorie && (
                 <span className="error-msg">{errors.categorie.message}</span>
              )} 
           </label>
           <label className='obligatoire'>Marque
             <select
              value={paiement.infovehicule.marque}
              {...register("marque", {
                onChange: (e) => {
                   handleInput(e);
                },
                   validate: (value) => value !== "" || "Veuillez selection la marque.",
             })}
             >
            <option value="">---</option>
            {marques?.length > 0 && marques.map((marque) => (
               <option value={marque.id} key={marque.id}>{ marque.title }</option>
              ))
               }
             </select>
              {errors?.marque && (
                //   <>
                //    {["validate"]?.map((errorType) => (
                //        errors.infovehicule.marque?.type === errorType && (
                //        <span key={errorType} className="error-msg">
                //            {errors.marque.message}
                //        </span>
                //       )
                //     ))}
                //  </>
                <span className="error-msg">{errors.marque.message}</span>
              )}
          </label>
        </div>
        <div className='input-group'>
          <label className='obligatoire'>Modèle
          
             <select
               value={paiement.infovehicule.modele}
               name='modele'
               {...register("modele", {
                 onChange: (e) => {
                    handleInput(e); 
                },
               validate: (value) => value !== "" || "Veuillez selectionner la modèle.",
             })}
             
             >
               <option value="">---</option>
               { selectModeles.length > 0 && selectModeles.map((modele) => (
                <option value={modele.id} key={modele.id}>{ modele.title }</option>
               ))}
             </select>
             {(errors.modele && errors.modele.type === "validate") && (
                <span className="error-msg">{errors.modele.message}</span>
              )}
          </label>
      
         { ChassisComponent ({setShowModal})}
        </div>
        <div className='input-group'>
          <label className='obligatoire'>PTAC
             <input type='numeric'
               name='ptac'
               value={paiement.infovehicule.ptac || 0}
               {...register("ptac", {
                required: "Le PTAC est obligatoire",
                min: {
                  value: 1,
                  message: "Le PTAC ne peut pas être inférieur à 1 kg"
                },
                max: {
                  value: 10000,
                  message: "Le PTAC ne peut pas dépasser 10 000 kg"
                },
                onChange: (e) => handleInput(e),
                validate: (value) => 
                  value % 50 === 0 || "Le PTAC doit être un multiple de 50 kg" // Validation custom
              })}
               step="50"
             />
             {errors?.ptac && (
                <span className="error-msg">
                    {errors.ptac.message}
                </span>
             )}
          </label>
          <label className='obligatoire'>PV en KG
             <input type='numeric'
               name='poidsAVide'
               value={paiement.infovehicule.poidsAVide || 0}
               {...register("poidsAVide", {
                required: "Le poids à vide est obligatoire",
                min: {
                  value: 50,
                  message: "Le Poids à vide ne peut pas être inférieur à 50 kg"
                },
                onChange: (e) => handleInput(e),
                validate: (value) => 
                  value % 50 === 0 || "Le Poids à vide doit être un multiple de 50 kg" // Validation custom
               })}
             />
             {errors?.poidsAVide && (
                <span className="error-msg">
                    {errors.poidsAVide.message}
                </span>
               )}
          </label>
        </div>
        <div className='input-group'>
          <label className='obligatoire'>Puissance fiscale (CV)
            <input type='numeric'
              name='puissanceFiscale'
              value={paiement.infovehicule?.puissanceFiscale || 0}
              {...register("puissanceFiscale", {
                required: "La puissance fiscale est obligatoire",
                onChange: (e) => handleInput(e),
                validate: (value) => 
                  (value % 1 === 0 && value > 0) || "La puissance fiscale doit être un multiple de 1" // Validation custom
              })}
            />
            {errors?.puissanceFiscale && (
                <span className="error-msg">
                    {errors.puissanceFiscale.message}
                </span>
               )}
          </label>
          <label className='obligatoire'>Charge Utile (KG)
            <input type='numeric'
              name='chargeUtile'
              value={paiement.infovehicule?.chargeUtile || 0}
              {...register("chargeUtile", {
                required: "La charge utile est obligatoire",
                min: {
                  value: 1,
                  message: "La charge utile ne peut pas être inférieure à 1"
                },
                max: {
                  value: 1000,
                  message: "La charge utile ne peut pas dépasser 1000"
                },
                onChange: (e) => handleInput(e),
                validate: (value) => 
                  value % 1 === 0 || "La charge utile doit être un multiple de 1" // Validation custom
               })}
              />
              {errors.chargeUtile && (
                <span className="error-msg">
                    {errors.chargeUtile.message}
                </span>
               )}
            </label> 
        </div>
        <div className='input-group'>
        <label className='obligatoire'>Couleur
            <Controller
                name="infovehicule.couleur"
                control={control}
                rules={{
                  validate: value => value !== "" || "La couleur est obligatoire."
                }}
                render={({ field, fieldState }) => (
                  <ColorSelect
                    onChange={(value) => {
                      field.onChange(value);
                      setShowOtherColor(value === "autre");
                      setPaiement(prev => ({
                        ...prev,
                        infovehicule: {
                          ...prev.infovehicule,
                          couleur: value
                        }
                      }));
                    }}
                    value={paiement.infovehicule.couleur}
                    setShowOtherColor={setShowOtherColor}
                    error={fieldState.error}
                  />
                )}
              />
              {errors?.infovehicule?.couleur && (
                <span className="error-msg">
                  {errors.infovehicule.couleur.message}
                </span>
              )}
              
          </label>
          <label className='obligatoire'>Date de Prémière mise en circulation
              <input type='date'
                name='dateMiseCirculation'
                max={new Date().toISOString().split('T')[0]}
                value={paiement.infovehicule.dateMiseCirculation || ''}
                {...register("dateMiseCirculation", {
                    required: "La date est obligatoire",
                    validate: {
                      notFuture: (value) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0); // Reset time pour comparaison
                        const selectedDate = new Date(value);
                        return selectedDate <= today || "La date ne peut pas être dans le futur";
                      }
                    },
                    onChange: (e) => handleInput(e) // Votre gestionnaire existant
                })}
              />
              {errors?.dateMiseCirculation && (
                <span className="error-msg">
                    {errors.dateMiseCirculation.message}
                </span>
               )}
          </label>
        </div>
        <div className='input-group'>
           <label className='obligatoire'>Pays de provenance
              <select
                name="paysProvenance"
                value={paiement.infovehicule.paysProvenance || ""}
                {...register("infovehicule.paysProvenance", {
                    onChange: (e) => {
                       handleInput(e);
                    },
                  validate: (value) => value !== "" || "Ce champ est obligatoire.",
                })}
                >
                 <option value="">---</option>
               { pays.length > 0 && pays.map((pays,index) => (<option value={pays.nom } key={index}> { pays.nom }</option>)) }
              </select> 
              {errors.infovehicule?.paysProvenance && (
                 <span className="error-msg">{ errors.infovehicule.paysProvenance.message }</span>
              )}  
           </label>
           <label className='obligatoire'>Pays de destination finale
              <select
                name="paysDestination"
                value={paiement.infovehicule?.paysDestination || ""}
                {...register("paysDestination", {
                    onChange: (e) => {
                       handleInput(e);
                    },
                    validate: {
                        required: value => value !== "" || "Ce champ est obligatoire",
                        differentFromOrigin: value => 
                          value !== paiement.infovehicule.paysProvenance || 
                          "Le pays de destination doit être différent du pays d'origine"
                      }
                  })}
                >
                 <option value="">---</option>
               { pays.length > 0 && pays.map((pays,index) => (<option value={pays.nom } key={index}> { pays.nom }</option>)) }
              </select> 
              {errors.infovehicule?.paysDestination && (
                 <span className="error-msg">{ errors.infovehicule.paysDestination.message }</span>
              )}  
         </label>
        </div>
        <div className='button-group'>
            <button type='submit' className=''>Suivant</button>
        </div>
        </form>
    </div>
  )
}

export default StepOne